module.exports = __webpack_public_path__ + "static/media/mini-logo.f17bd64d.svg";